import * as React from 'react';
import { observer } from 'mobx-react';
import './cardPaymentConfirmation.module.scss';
import { CardPaymentState, SplitMethodFormState } from './states/CardPaymentState';
import { CardSummaryView } from './CardSummaryView';

type SplitProps = {
  priceWithoutTax: number;
  priceWithTax: number;
  state: SplitMethodFormState;
};

const SplitSummaryView = ({ priceWithoutTax, priceWithTax, state }: SplitProps) => {
  const { currentOption } = state;
  const monthlyPayment = state.computeMonthlyPaymentWithTax(priceWithoutTax, priceWithTax, currentOption.splitCount);
  return (
    <div styleName="split-summary">
      <div styleName="option">{state.currentOption.label}</div>
      <div styleName="monthly-price">
        <span styleName="price-number">{monthlyPayment.toLocaleString()}</span>
        <span styleName="price-unit">円(税込)</span>
        {currentOption.splitCount > 1 && <span styleName="split-duration">/ 1month x {state.splitCount}</span>}
      </div>
    </div>
  );
};

type Props = {
  state: CardPaymentState;
  priceWithoutTax: number;
  priceWithTax: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onModificationRequested: () => any;
};

export const CardPaymentConfirmation = observer(
  class CardPaymentConfirmation extends React.Component<Props> {
    render() {
      const { state, priceWithoutTax, priceWithTax, onModificationRequested } = this.props;
      return (
        <div styleName="payment-method-confirmation">
          <CardSummaryView
            card={state.currentCard.getOrThrow()}
            onModificationRequested={() => {
              state.useNewCard = true;
              onModificationRequested();
            }}
          />
          <SplitSummaryView
            priceWithoutTax={priceWithoutTax}
            priceWithTax={priceWithTax}
            state={state.splitMethodForm}
          />
        </div>
      );
    }
  }
);
